// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenshotPdfContentTitle--e0wZ_ {
  color: #343c42;
}[dir] .screenshotPdfContentTitle--e0wZ_ {
  margin-top: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ScreenshotContent/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAEhB,CAHA;EAEE,gBAAgB;AAClB","sourcesContent":[".screenshotPdfContentTitle {\n  color: #343c42;\n  margin-top: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screenshotPdfContentTitle": `screenshotPdfContentTitle--e0wZ_`
};
export default ___CSS_LOADER_EXPORT___;
